import { render } from "./Heart.vue?vue&type=template&id=4a506fe3&scoped=true"
const script = {}

import "./Heart.vue?vue&type=style&index=0&id=4a506fe3&scoped=true&lang=css"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4a506fe3"]])

export default __exports__